import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

const createAsyncReducer = buildCreateSlice({
    creators: { asyncThunk: asyncThunkCreator }
});

export default createAsyncReducer;